import { render, staticRenderFns } from "./PatreonLabel.vue?vue&type=template&id=58303658&scoped=true"
import script from "./PatreonLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatreonLabel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PatreonLabel.vue?vue&type=style&index=0&id=58303658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58303658",
  null
  
)

export default component.exports